import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import { is, or } from "@amcharts/amcharts4/core";
import { order } from "@amcharts/amcharts4/.internal/core/utils/Number";

declare var ko: any;

export class config_segments_template extends vnTemplate {


    protected filter: filterSimple_template;
    protected pagination: pagination_template;
    protected resultInfos: resultsInfo_template;

    protected getTemplateHtml(): string {
        return /*html*/`
                <div class="list-header w-justify" >

                    <div class="w-left">
                        <button data-bind="click: function() { onClickShowPopUp('add') }" class="btn secondary icon i-add" type="button">Add Segment</button>
                    </div>

                    <div class="w-center">
                        ${this.filter.getHtmlBuild()}
                    </div>

                    <div class="w-right">
                        ${this.pagination.getHtmlBuild()}
                    </div>
                </div>


                <div class="w-list-results" id="list-results">
                    <table class="list-results">
                        ${this.resultInfos.getHtmlBuild()}
                        <thead>
                            <tr>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'id') }, css: { 'list-sort-desc': orderByAndDirection()=='id_DESC', 'list-sort-asc': orderByAndDirection()=='id_ASC' }">ID</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'name') }, css: { 'list-sort-desc': orderByAndDirection()=='name_DESC', 'list-sort-asc': orderByAndDirection()=='name_ASC' }">Name</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'activeStatus') }, css: { 'list-sort-desc': orderByAndDirection()=='activeStatus_DESC', 'list-sort-asc': orderByAndDirection()=='activeStatus_ASC' }">Active Status</span></th>
                                <!-- ko if: showParentName() -->
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'parentName') }, css: { 'list-sort-desc': orderByAndDirection()=='parentName_DESC', 'list-sort-asc': orderByAndDirection()=='parentName_ASC' }">Parent Name</span></th>
                                <!-- /ko -->
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateCreated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateCreated_DESC', 'list-sort-asc': orderByAndDirection()=='dateCreated_ASC' }">Date Created</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateUpdated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateUpdated_DESC', 'list-sort-asc': orderByAndDirection()=='dateUpdated_ASC' }">Date Updated</span></th>

                            </tr>
                        </thead>
                        <tbody data-bind="foreach: segments">
                            <tr class="cursor">
                                <td data-bind="event: { click: $parent.onClickEditSegment }"><a class="right-click"><span data-bind="text: id"></span></a></td>
                                <td data-bind="event: { click: $parent.onClickEditSegment }"><a class="right-click"><span data-bind="text: name"></span></a></td>
                                <td data-bind="event: { click: $parent.onClickEditSegment }"><a class="right-click"><span data-bind="text: activeStatus"></span></a></td>
                                <!-- ko if: $parent.showParentName() -->
                                <td data-bind="event: { click: $parent.onClickEditSegment }"><a class="right-click"><span data-bind="text: parentName"></span></a></td>
                                <!-- /ko -->
                                <td data-bind="event: { click: $parent.onClickEditSegment }"><a class="right-click"><span data-bind="text: dateCreated"></span></a></td>
                                <td data-bind="event: { click: $parent.onClickEditSegment }"><a class="right-click"><span data-bind="text: dateUpdated"></span></a></td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="w-lightbox light-theme" data-bind="css: { 'is-visible' : isVisible }">
                    <div class="lightbox-content">

                        <div class="w-form lightbox-form">
                            <div class="form-header">
                                <h3 class="form-title" data-bind="text: popupAction() + ' Segment'"></h3>
                                <button type="button"  data-bind="event: { click: onClickCancel }" class="close-button icon i-close-2"></button>
                            </div>

                            <div class="form-body">
                                <div class="form-group">
                                    <label class="form-label">Name</label>
                                    <div class="w-input">
                                        <input type="text" name="name" id="name"  class="input-text" data-bind="value: selectedSegment().name">
                                    </div>
                                </div>
                                <!-- ko if: showParentName() -->
                                <div class="form-group">
                                    <label class="form-label">Parent Name</label>
                                    <div class="w-input">
                                        <input type="text" name="parentName" id="parentName"  class="input-text" data-bind="value: selectedSegment().parentName">
                                    </div>
                                </div>
                                <!-- /ko -->
                                <div class="form-group">
                                    <label class="form-label">Active Status</label>
                                    <select name="activeStatus" id="activeStatus" class="input-select" data-bind="value: selectedSegment().activeStatus">
                                        <option value="1">Active</option>
                                        <option value="0">Inactive</option>
                                    </select>
                                </div>
                            </div>

                            <div class="form-footer">
                                <button type="button" data-bind="event: { click: onClickCancel }" class="btn border only-icon icon">Cancel</button>
                                <button type="button" data-bind="event: { click: onClickSave }" class="btn border only-icon icon">Save</button>
                            </div>
                        </div>

                    </div>
                </div>


         `;
    }

    protected initPartial(): void {
        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller);

        let brandId = this.caller.getIdBrand();
        if (brandId == 6) {
            this.getTemplateViewModel().showParentName(true);
        }

    }

    protected getTemplateName(): string {
        return "config_segments_template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

    protected buildViewModel(): any {
        let self = this
        return {
            segments: ko.observableArray([]),
            orderBy: ko.observable("dateUpdated"),
            orderByDirection: ko.observable("DESC"),
            orderByAndDirection: ko.observable("dateUpdated_DESC"),
            isVisible: ko.observable(false),
            showParentName: ko.observable(false),
            popupAction: ko.observable("add"),
            selectedSegment: ko.observable({
                id: null,
                name: '',
                parentName: '',
                activeStatus: 0,
                dateCreated: null,
                dateUpdated: null
            }),
            onClickEditSegment: function (data, event) {
                var segment = self.getTemplateViewModel().segments().find(segment => segment.id === data.id);
                self.getTemplateViewModel().selectedSegment({
                    ...segment,
                    activeStatus: segment.activeStatus === true ? 1 : 0
                });
                self.onClickShowPopUp('edit');
            },
            onClickReorder: function (value, data, event) {
                self.onClickReorder(value, data, event);
            },
            onClickShowPopUp: function (value, data, event) {
                self.onClickShowPopUp(value)
            },
            onClickCancel: function (value, data, event) {
                self.onClickCancel()
            },
            onClickSave: function (value, data, event) {
                self.onClickSave()
            }
        }
    }


    public getViewModelForRequest() {

        return {
            orderBy: this.getTemplateViewModel().orderBy(),
            orderByDirection: this.getTemplateViewModel().orderByDirection(),
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection(),
            pagination: this.getTemplateViewModel().pagination,
            filters: {
                keywords: this.getTemplateViewModel().filter.filterKeyword(),
            }
        }
    }

    public onClickReorder(value, data, event) {

        data.orderBy(value);

        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.segmentsListReorder();
    }

    public setSegments(segments) {

        this.getTemplateViewModel().segments(segments);
    }

    public setResultInfo(nbResults, nbPages, execTime ) {

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public onClickShowPopUp(action) {
        if (action === 'add') {
            this.getTemplateViewModel().selectedSegment({
                id: null,
                name: '',
                parentName: '',
                activeStatus: 0,
                dateCreated: null,
                dateUpdated: null
            });
        }

        this.getTemplateViewModel().popupAction(action);
        this.getTemplateViewModel().isVisible(true);
    }

    public onClickCancel() {
        this.getTemplateViewModel().isVisible(false);
    }

    public onClickSave() {

        this.getTemplateViewModel().isVisible(false);
        this.caller.saveSegment(this.getTemplateViewModel().selectedSegment());
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/configSegmentsList_template.ts